import React, { Component, useCallback } from 'react';
import SmileIcon from '@shared/assets/icons/v2/smile.svg';
import { MBView } from '@shared/components/MBView';
import { MBEmojiPicker } from '@shared/components/form';
import { MBTouchableIcon } from '@shared/components/touchable';
import { Colors, grid } from '@shared/styles';
import { useIsDesktop } from '@shared/util/hooks';
import { MBOverlay } from '@shared/util/overlay';
import { Styles } from './styles';

interface Props {
  onSelect(emoji: string): void;
}

export function MBEmojiButton({ onSelect }: Props) {
  const isDesktop = useIsDesktop();
  const openPicker = useCallback(
    (button: Component) =>
      MBOverlay.show({
        parent: button,
        closeOnBackdropPress: true,
        position: ({ top, right }) => ({
          position: 'absolute',
          bottom: window.innerHeight - top,
          right: window.innerWidth - right - grid(1),
        }),
        component: () => <MBEmojiPicker onSelect={onSelect} />,
      }),
    [onSelect],
  );

  if (!isDesktop) {
    return null;
  }
  return (
    <>
      <MBView style={Styles.alignBottom}>
        <MBTouchableIcon
          source={SmileIcon}
          color={Colors.v2.purple}
          noPadding
          style={{ width: 40, height: 40 }}
          onPress={openPicker}
        />
      </MBView>
    </>
  );
}
